import { formatMoney } from "./format";

export const COPY = {
  dayClosed:
    "This day's book is closed. Changing it would mess up the next day's opening cash.",
  dayClosedHint: "Closed day — edit after that day is open, or add a new entry today.",
  downPaymentLocked: "Down payment can change only before any installment is collected.",
  deleteExpense: "Delete this expense? Money will go back into the daily book.",
  deleteSale: "Delete this sale and its installments? Money will leave the daily book.",
  deleteInstallment: "Delete this installment? Remaining will go up, and the daily book will update.",
  deleteVendor: "Delete this vendor? Only vendors with no expenses can be removed.",
  deleteProject: "Delete this project? Only projects with no sales or expenses can be removed.",
  deleteBank: "Delete this bank? It can only be removed if no cheque, online, or pay order used it.",
  creditHint: "Udhar goes on the vendor's khata. Today's cash does not go down.",
  cashHint: "Taken from today's cashbook.",
  chequeHint: "Cheque number, bank, and picture are required.",
  onlineHint: "Transaction ID, bank, and picture are required.",
  payOrderHint: "Pay order number, bank, and picture are required.",
  bankHint: "Which of your accounts this money went through.",
  settleHint: "Pay udhar with cash, cheque, online or pay order. Then the daily book goes down.",
  needVendor: "Add a vendor first, then write the expense.",
  needBank: "Add a bank first. Cheque, online and pay order need one.",
  planLocked: "Paid months stay as they are. Only remaining months can change.",
};

export const LOG_ENTITY_LABEL = {
  expense: "Expense",
  sale: "Sale",
  installment: "Installment",
  vendor: "Vendor",
  vendor_payment: "Vendor payment",
  bank: "Bank",
};

export const LOG_ACTION_LABEL = {
  create: "Added",
  update: "Changed",
  delete: "Removed",
};

const LOG_FIELD_LABEL = {
  title: "Title",
  amount: "Amount",
  note: "Note",
  category: "Type",
  propertyName: "Plot / unit",
  buyerName: "Customer",
  buyerPhone: "Phone",
  totalAmount: "Total price",
  downPayment: "Down payment",
  installmentMonths: "Months",
  remainingAmount: "Remaining",
  receivedAmount: "Paid so far",
  monthlyInstallment: "Monthly",
  status: "Status",
  date: "Date",
  paymentType: "Paid by",
  vendorId: "Vendor",
  name: "Name",
  phone: "Phone",
  accountTitle: "Account title",
  accountNumber: "Account number",
  bankId: "Bank",
  bank: "Bank",
};

const SKIP_DIFF = new Set([
  "id",
  "_id",
  "builder",
  "project",
  "sale",
  "ledgerEntry",
  "downPaymentEntry",
  "installmentPlan",
  "khata",
  "payments",
  "createdAt",
  "updatedAt",
  "__v",
]);

const MONEY_FIELDS = new Set([
  "amount",
  "totalAmount",
  "downPayment",
  "remainingAmount",
  "receivedAmount",
  "monthlyInstallment",
]);

const prettyValue = (field, value) => {
  if (value == null || value === "") return "—";
  if (MONEY_FIELDS.has(field) && Number.isFinite(Number(value))) return formatMoney(value);
  if (typeof value === "object") {
    if (value.name) return value.name;
    return JSON.stringify(value);
  }
  return String(value);
};

export const changedFields = (before, after) => {
  const left = before || {};
  const right = after || {};
  const keys = [...new Set([...Object.keys(left), ...Object.keys(right)])].filter(
    (key) => !SKIP_DIFF.has(key)
  );

  return keys
    .filter((key) => JSON.stringify(left[key]) !== JSON.stringify(right[key]))
    .map((key) => ({
      key,
      field: LOG_FIELD_LABEL[key] || key,
      from: prettyValue(key, left[key]),
      to: prettyValue(key, right[key]),
    }));
};

export const hasInstallments = (sale) =>
  Boolean(sale?.payments?.length) || Number(sale?.receivedAmount) > Number(sale?.downPayment);
